"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = formatNumber;
exports.sortAlphabetically = sortAlphabetically;
exports.sortSearchParam = sortSearchParam;
exports.sortUniqueItems = sortUniqueItems;
exports.splitArrToChunks = splitArrToChunks;
/**
 *
 * @param {Array} arr Assigned Array to sort alphabetically
 * @returns {Array} sorted Array
 */
function sortAlphabetically(arr) {
  return arr?.sort((a, b) => a.value.localeCompare(b.value, 'en', {
    sensitivity: 'base'
  }));
}

/**
 *
 * @param {Array} arr Assigned Array to Remove Duplicated Elements
 * @returns {Array} sorted Array
 */
function sortUniqueItems(arr) {
  return [...arr.reduce((map, obj) => map.set(obj.value, obj), new Map()).values()];
}

/**
 *
 * @param {Node} el Element Filters by Query
 * @param {String} q Search Query Paramater
 * @returns {Array} sorted Array
 */
function sortSearchParam(el, q) {
  return el?.toString().toLowerCase().indexOf(q.toLowerCase()) > -1;
}

/**
 *
 * @param {Array} arr Accepts Array of Data
 * @param {Number} size Size of each chunks
 * @returns {Array} sorted Array
 */
function splitArrToChunks(arr, size) {
  return Array.from({
    length: Math.ceil(arr.length / size)
  }, (v, i) => arr.slice(i * size, i * size + size));
}

/**
 *
 * @param {Number} num Accepts one digit number
 * @returns {Number} Format to two digits number
 */
function formatNumber(num) {
  return num.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGroupping: false
  });
}